import firebase from 'firebase/app';
import LogRocket from 'logrocket';

import { Collections } from './Collections';
import { AnalyticsEvent } from './models/AnalyticsEvent';

import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/messaging';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCMiDRPPBIDOTafCvEKs_i2P2S8Lacvfa8",
    authDomain: "trygkalk.firebaseapp.com",
    projectId: "trygkalk",
    storageBucket: "trygkalk.appspot.com",
    messagingSenderId: "425658390801",
    appId: "1:425658390801:web:633fd937e8b9e68a7694b0",
    measurementId: "G-YV6WTEXCDV",
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

//Analytics MUST be initialized before other firebase products
export const analytics = firebase.analytics()

/*
const a = firebase.analytics()
export const analytics = {
    ...a,
    logEvent: function (eventName: string, eventParams?: { [prop: string]: any }) {
        a.logEvent(eventName, eventParams)
        console.log(eventName, eventParams)
    }
}*/

export const auth = firebase.auth();

const pdb = firebase.firestore();
export const persistedDb = pdb
//Enable persistence only if app is installed
if (window.matchMedia('(display-mode: standalone)').matches) {
    pdb.enablePersistence()
}

export const db = firebase.firestore();

export const storage = firebase.storage()

export const messaging = firebase.messaging

export async function registerToken(userId: string) {
    if (messaging.isSupported()) {
        const messaging = firebase.messaging()
        await Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                analytics.logEvent(AnalyticsEvent.FCM_TOKEN_GRANTED, {
                    userId,
                    permission,
                })
                return messaging.getToken({ vapidKey: 'BO3Y16sjKvA7D0aExCGzbNqLGdgWOVflcWMe46vtKc_pzD2dz1Pd48VXXkLcGICAUmkW7utSviGB9zRat2T_ook' })
                    .then((token: string) => {
                        if (token) {
                            persistedDb.collection(Collections.FCM_TOKENS).doc(token).set({
                                token,
                                userId: userId,
                            })
                            analytics.logEvent(AnalyticsEvent.FCM_TOKEN_SUCCESS, {
                                userId,
                            })
                        } else {
                            analytics.logEvent(AnalyticsEvent.FCM_TOKEN_MISSING_ERROR, {
                                userId,
                                token,
                            })
                        }
                    }).catch((error) => {
                        console.error(error)
                        analytics.logEvent(AnalyticsEvent.FCM_GET_TOKEN_ERROR, {
                            userId,
                            error,
                        })
                    })
            } else {
                analytics.logEvent(AnalyticsEvent.FCM_TOKEN_DENIED, {
                    userId,
                    permission,
                })
            }
        })
    } else {
        analytics.logEvent(AnalyticsEvent.FCM_TOKEN_NOT_SUPPORTED, {
            userId,
            appIsInstalled: window.matchMedia('(display-mode: standalone)').matches,
            userAgent: navigator.userAgent,
        })
    }
}

auth.onAuthStateChanged(async user => {
    if (user) {
        analytics.setUserId(user.uid)
        LogRocket.identify(user.uid, {
            name: user.displayName || '',
            email: user.email || '',
        })
        if (Notification.permission === 'granted') {
            registerToken(user.uid)
        }
    }
})

LogRocket.getSessionURL(function (sessionURL) {
    analytics.logEvent('LogRocket', {
        hitType: 'event',
        eventCategory: 'LogRocket',
        eventAction: sessionURL,
    })
});

/*
if (window.location.hostname === 'localhost') {
    db.useEmulator("localhost", 8080)
    persistedDb.useEmulator("localhost", 8080)
    auth.useEmulator("http://localhost:9099")
    storage.useEmulator("localhost", 9199)
}
*/

db.collection(Collections.APPLICATION_VERSIONS).doc('Release').onSnapshot(snap => {
    const releaseVersionStorageKey = 'releaseVersion'
    const storedVersion = localStorage.getItem(releaseVersionStorageKey)
    const nextVersion = snap.data()?.version
    if (String(nextVersion) !== String(storedVersion)) {
        localStorage.setItem(releaseVersionStorageKey, nextVersion)
        if (storedVersion) {
            alert('Appen må oppdateres. Dette skjer automatisk')
            window.onbeforeunload = null
            window.location.reload()
        }
    }
}, (error) => {
    console.error(error)
    analytics.logEvent(AnalyticsEvent.GET_APP_RELEASE_VERSION_ERROR, { error })
})
// Configure FirebaseUI.
export const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // We will display Google and Facebook as auth providers.
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ]
};
